export const updateStore=(data) => {
    return {
    type: "UPDATE",
    payload: data
}
}